import { SagaIterator } from "redux-saga";
import { call, put, select, takeLatest } from "typed-redux-saga";
import { Action } from "typescript-fsa";

import { ActivityActions, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";

import { putErrorNotification } from "../../../utilities/notificationUtils";
import { RESOURCE_KEYS } from "../../../localization";
import { searchOpenRegisterRecords } from "../../../utilities/rpcHelper";
import { ModulfDataSelectors } from "../../../utilities/selectors/modulfDataSelectors";

import { SEARCH_OPENREGISTER_RECORDS } from "../actions";
import { OpenregisterSearchModalDescriptor } from "../descriptors";

export function* searchOpenRegisterRecordsSaga(): SagaIterator<void> {
	yield* takeLatest(
		SEARCH_OPENREGISTER_RECORDS,
		function* (action: Action<{ activityId: string; pageIndex: number; query: string }>) {
			const { activityId, pageIndex, query } = action.payload;

			yield* put(ActivityActions.setData({ activityId, data: { loading: true, error: false } }));

			const activity = yield* select(ActivitySelectors.activityById(activityId));
			if (!activity || !OpenregisterSearchModalDescriptor.isInstance(activity.descriptor)) {
				return;
			}

			const { openregisterPath, mappingConfigurationId, sourceActivityId } = activity.descriptor;

			const data = yield* select(ModulfDataSelectors.selectTaskDocument(sourceActivityId));
			if (!data) {
				yield* put(ActivityActions.setData({ activityId, data: { loading: false } }));
				return;
			}

			const path = openregisterPath.substring(openregisterPath.indexOf("/root/"));

			try {
				const page = yield* call(
					searchOpenRegisterRecords,
					data.id,
					path,
					mappingConfigurationId,
					pageIndex,
					query
				);
				yield* put(ActivityActions.setData({ activityId, data: { loading: false, page } }));
			} catch (error) {
				yield* put(ActivityActions.setData({ activityId, data: { loading: false, error: true } }));
				yield* call(
					putErrorNotification,
					{ key: RESOURCE_KEYS.features.notification.error.unexpectedError },
					error,
					activityId,
					"openregisterSelection"
				);
			}
		}
	);
}
